import { Observable } from "rxjs/Observable"

import {
    TOPIC_ITEM_REQUEST,
    TOPIC_ITEM_RESPONSE,
    TOPIC_ITEM_CACHED_RESPONSE,
    TOPIC_ITEM_ERROR_RESPONSE,
    TOPIC_FINGERPRINT_REQUEST,
    TOPIC_FINGERPRINT_RESPONSE,
    TOPIC_FINGERPRINT_CACHED_RESPONSE,
    TOPIC_FINGERPRINT_ERROR_RESPONSE,
    TOPIC_ITEM_SAVE_REQUEST,
    TOPIC_ITEM_SAVE_RESPONSE,
    TOPIC_ITEM_SYNC_REQUEST,
    TOPIC_LIST_REQUEST,
    TOPIC_LIST_RESPONSE,
    TOPIC_LIST_CACHED_RESPONSE,
    TOPIC_LIST_ERROR_RESPONSE,
    TOPIC_LIST_COUNT_REQUEST,
    TOPIC_LIST_COUNT_RESPONSE,
    TOPIC_LIST_COUNT_CACHED_RESPONSE,
    TOPIC_LIST_COUNT_ERROR_RESPONSE,
    TOPIC_FINGERPRINT_PREVIEW_RESPONSE,
    TOPIC_FINGERPRINT_PREVIEW_ERROR_RESPONSE,
    TOPIC_FINGERPRINT_PREVIEW_REQUEST,
} from "../actions/action-types"
import {
    topicItemResponse,
    topicItemSaveResponse,
    topicItemCachedResponse,
    topicItemErrorResponse,
    topicFingerprintResponse,
    topicFingerprintCachedResponse,
    topicFingerprintErrorResponse,
    topicItemSyncResponse,
    topicItemSyncErrorResponse,
    topicListResponse,
    topicListCachedResponse,
    topicListErrorResponse,
    topicListCountResponse,
    topicListCountCachedResponse,
    topicListCountErrorResponse,
    topicItemSaveErrorResponse,
    topicFingerprintPreviewResponse,
    topicFingerprintPreviewErrorResponse,
} from "../actions/topic-actions"
import { unauthenticated } from "../actions/authentication-actions"
import { mapRequestError } from "./default-epics/epic-utils"

import {
    getTopicItem,
    getTopicList,
    getTopicListCount,
    putTopicItem,
    postTopicItem,
    postTopicSync,
    getTopicFingerprint,
    postTopicFPBuilder,
} from "../api/topic-api"
import {
    requestItemEpic,
    requestListEpic,
    requestListCountEpic,
    requestItemSaveHandler,
    requestItemSaveWithPlaceholdersEpic,
    callbackActionCreatorEpic,
} from "./default-epics/default-entity-epics"
import {
    normalisingFields,
    hydrate as hydrateTopic,
} from "../models/entities/topic"

export const requestTopicItemEpic = requestItemEpic(
    TOPIC_ITEM_REQUEST,
    getTopicItem,
    "topics",
    hydrateTopic,
    normalisingFields,
    topicItemResponse,
    topicItemCachedResponse,
    topicItemErrorResponse
)

export const requestTopicFingerprintEpic = requestItemEpic(
    TOPIC_FINGERPRINT_REQUEST,
    getTopicFingerprint,
    "topicFingerprints",
    (fingerprint) => fingerprint,
    [],
    topicFingerprintResponse,
    topicFingerprintCachedResponse,
    topicFingerprintErrorResponse
)

export const requestTopicFingerprintBuilderEpic = (action$, { getState }) =>
    action$
        .ofType(TOPIC_FINGERPRINT_PREVIEW_REQUEST)
        .mergeMap(
            ({
                mappings,
                removedConcepts,
                topicName,
                callbackActionCreator,
            }) => {
                const { token } = getState().authentication
                return postTopicFPBuilder(token, {
                    mappings,
                    without_concepts: removedConcepts,
                    name: topicName,
                    wef_owned: true,
                })
                    .map((data) =>
                        topicFingerprintPreviewResponse(
                            data.fp,
                            callbackActionCreator
                        )
                    )
                    .catch((error) =>
                        Observable.of(
                            mapRequestError(
                                error,
                                unauthenticated,
                                topicFingerprintPreviewErrorResponse,
                                callbackActionCreator
                            )
                        )
                    )
            }
        )

export const requestTopicListEpic = requestListEpic(
    TOPIC_LIST_REQUEST,
    getTopicList,
    "topics",
    topicListResponse,
    topicListCachedResponse,
    topicListErrorResponse
)

export const requestTopicListCountEpic = requestListCountEpic(
    TOPIC_LIST_COUNT_REQUEST,
    getTopicListCount,
    "topicCount",
    topicListCountResponse,
    topicListCountCachedResponse,
    topicListCountErrorResponse
)

const topicItemSaveRequestHandler = requestItemSaveHandler(
    putTopicItem,
    postTopicItem,
    "topic",
    topicItemSaveResponse,
    topicItemSaveErrorResponse
)

export const requestTopicItemSaveEpic = requestItemSaveWithPlaceholdersEpic(
    TOPIC_ITEM_SAVE_REQUEST,
    topicItemSaveRequestHandler,
    "topic"
)

export const responseTopicCallbackEpic = callbackActionCreatorEpic(
    TOPIC_ITEM_RESPONSE,
    TOPIC_ITEM_SAVE_RESPONSE,
    TOPIC_ITEM_CACHED_RESPONSE,
    TOPIC_ITEM_ERROR_RESPONSE,
    TOPIC_LIST_RESPONSE,
    TOPIC_LIST_CACHED_RESPONSE,
    TOPIC_LIST_ERROR_RESPONSE,
    TOPIC_LIST_COUNT_RESPONSE,
    TOPIC_LIST_COUNT_CACHED_RESPONSE,
    TOPIC_LIST_COUNT_ERROR_RESPONSE,
    TOPIC_FINGERPRINT_RESPONSE,
    TOPIC_FINGERPRINT_CACHED_RESPONSE,
    TOPIC_FINGERPRINT_ERROR_RESPONSE,
    TOPIC_FINGERPRINT_PREVIEW_RESPONSE,
    TOPIC_FINGERPRINT_PREVIEW_ERROR_RESPONSE
)

export const topicItemSyncRequestEpic = (action$, { getState }) =>
    action$.ofType(TOPIC_ITEM_SYNC_REQUEST).mergeMap(({ id }) => {
        const state = getState()
        const { token } = state.authentication
        return postTopicSync(token, id)
            .map((response) =>
                topicItemSyncResponse({
                    id,
                    data: response,
                })
            )
            .catch((error) =>
                Observable.of(
                    mapRequestError(
                        error,
                        unauthenticated,
                        topicItemSyncErrorResponse,
                        { id }
                    )
                )
            )
    })
